import { render, staticRenderFns } from "./DeliveryMetaData.vue?vue&type=template&id=4fbcbfb6"
import script from "./DeliveryMetaData.vue?vue&type=script&lang=js"
export * from "./DeliveryMetaData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports